import { createContext } from 'react';
import type { ISnackbarContext } from '@/contexts/Snackbar/ISnackbarContext';

const SnackbarContext = createContext<ISnackbarContext | null>(null);

export default SnackbarContext;
